function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBtnAddAddress = function SvgBtnAddAddress(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 1024 1024"
    },
    viewBox: "0 0 1024 1024"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M903.7 456H569.3l.5-335.7c0-30.9-25-56-55.9-56h-.1c-30.9 0-55.9 25-56 55.9l-.5 335.8h-337c-30.9 0-56 25-56 56s25 56 56 56h336.9l-.5 335.7c0 30.9 25 56 55.9 56h.1c30.9 0 55.9-25 56-55.9l.5-335.8h334.6c30.9 0 55.9-25 55.9-56s-25.1-56-56-56z",
    style: {
      fill: "#fff"
    }
  }));
};
export default SvgBtnAddAddress;